// Inbound Webhook
export const POST_INBOUND_WEBHOOK_REQUEST = "POST_INBOUND_WEBHOOK_REQUEST";
export const POST_INBOUND_WEBHOOK_SUCCESS = "POST_INBOUND_WEBHOOK_SUCCESS";
export const POST_INBOUND_WEBHOOK_FAILURE = "POST_INBOUND_WEBHOOK_FAILURE";

// Outbound Webhook
export const POST_OUTBOUND_WEBHOOK_REQUEST = "POST_OUTBOUND_WEBHOOK_REQUEST";
export const POST_OUTBOUND_WEBHOOK_SUCCESS = "POST_OUTBOUND_WEBHOOK_SUCCESS";
export const POST_OUTBOUND_WEBHOOK_FAILURE = "POST_OUTBOUND_WEBHOOK_FAILURE";

// PUT Inbound
export const PUT_INBOUND_WEBHOOK_REQUEST = "PUT_INBOUND_WEBHOOK_REQUEST";
export const PUT_INBOUND_WEBHOOK_SUCCESS = "PUT_INBOUND_WEBHOOK_SUCCESS";
export const PUT_INBOUND_WEBHOOK_FAILURE = "PUT_INBOUND_WEBHOOK_FAILURE";

// PUT Outbound
export const PUT_OUTBOUND_WEBHOOK_REQUEST = "PUT_OUTBOUND_WEBHOOK_REQUEST";
export const PUT_OUTBOUND_WEBHOOK_SUCCESS = "PUT_OUTBOUND_WEBHOOK_SUCCESS";
export const PUT_OUTBOUND_WEBHOOK_FAILURE = "PUT_OUTBOUND_WEBHOOK_FAILURE";

// Outbound Webhook List
export const FETCH_OUTBOUND_WEBHOOK_LIST_REQUEST = "FETCH_OUTBOUND_WEBHOOK_LIST_REQUEST";
export const FETCH_OUTBOUND_WEBHOOK_LIST_SUCCESS = "FETCH_OUTBOUND_WEBHOOK_LIST_SUCCESS";
export const FETCH_OUTBOUND_WEBHOOK_LIST_FAILURE = "FETCH_OUTBOUND_WEBHOOK_LIST_FAILURE";

// DELETE Outbound
export const DELETE_OUTBOUND_WEBHOOK_REQUEST = "DELETE_OUTBOUND_WEBHOOK_REQUEST";
export const DELETE_OUTBOUND_WEBHOOK_SUCCESS = "DELETE_OUTBOUND_WEBHOOK_SUCCESS";
export const DELETE_OUTBOUND_WEBHOOK_FAILURE = "DELETE_OUTBOUND_WEBHOOK_FAILURE";
